/*
 * 消息存档首页 - 右侧 - 文件组件
 * @Author: pwq
 * @Date: 2020-2-18
 * @Last Modified by: pwq
 */
import React, { useEffect, useState } from "react";
import styled from 'styled-components'
import {Popover} from 'antd'
import IconUpload from '../../img/upload.png'
import {fileFormat} from '../common/file/formatIcon'
import api from '../../apis/pc/conversation/conversation'
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
import {calFileSize} from "../../utils/utils";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #E9E9E9;
  padding: 12px 10px 0 10px;
  height: 94%;
`
const Main = styled.div`
  display: flex;
  padding: 4px;
  margin-bottom: 8px;
  justify-content: space-between;
  &.active {
    background: #F9F9F9;
    border-radius: 2px;
  }
`
const Content = styled.div`
  margin-right: 16px;
`
const Title = styled.div`
  width: 140px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
  color: #595959;
  margin-bottom: 4px;
`
const Size = styled.div`
  font-size: 12px;
  color: #BFBFBF;
`
const Time = styled.div`
  font-size: 12px;
  color: #BFBFBF;
  display: flex
`
const ShowImg = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 2px;
`
const UploadImg = styled.img`
  width: 16px;
  height: 13px;
  margin-left: 10px;
  cursor: pointer;
`
const NoData = styled.div`
  color: #BFBFBF;
  text-align: center;
  margin-top: 40px;
`
const File = (props) => {
  const {session} = props;
  const [uploadId, setUploadId] = useState(''); // 管理员编辑id
  const [pageInfo, setPageInfo] = useState({pageSize: 20, pageType: 1});
  const [list, setList] = useState([]); // 文件信息List
  const [hasMore, setHasMore] = useState(true); // 是否有下一页

  useEffect(() => {
    getChatMessage();
  }, [pageInfo])

  // 鼠标悬浮
  const handleVisibleChange = (id) => {
    setUploadId(id)
  }
  // 鼠标移除取消悬浮
  const handleLeave = () => {
    setUploadId(0);
  }
  const getChatMessage = () => {
    if (!session.sessionId) return;
    let params = {
      sessionId: session.sessionId,
      messageType: 2,
      ...pageInfo,
    }
    api.chatSearch(params).then(response => {
      if (response.code === 0) {
        let listArr = list.concat(response.data.list);
        listArr.map(item => {
          if (typeof(item.messageContent) === 'string') {
            item.messageContent = JSON.parse(item.messageContent);
          }
        })
        setHasMore(response.data.nextPage)
        setList(listArr);
      }
    })
  }
  // 下拉加载
  const handleScroll = (lastMessageId) => {
    pageInfo.lastMessageId = lastMessageId
    pageInfo.pageType = 3
    setPageInfo({...pageInfo});
  }
  // 点击定位
  // const goChatInfo = (item) => {
  //   handleChange({setType: 'message', ...item, sessionId: session.sessionId})
  //   let params = {
  //     type: 2,
  //     locationInfo: 'isLocation',
  //   }
  //   // 2表示文件，isLocation表示定位点击，原因，当定位点击以后，切换tab需还原，正常切换则不需要
  //   handleType({...params})
  // }
  // 下载
  const downloadImg = (url, name) => {
    name = name || url
    // fetch抓取图片数据
    fetch(url).then(response => {
      if (response.status === 200)
        // 返回的.blob()为promise，然后生成了blob对象，此方法获得的blob对象包含了数据类型，十分方便
        return response.blob()
      throw new Error(`status: ${response.status}.`)
    }).then(blob => {
      // 获取到blob对象
      downloadFile(name, blob)
    }).catch(error => {
      console.log("failed. cause:", error)
    })
    function downloadFile(fileName) {
      const anchor = document.createElement('a')
      // 创建指向blob对象地址
      anchor.href = fileName
      document.body.appendChild(anchor)
      anchor.click()
    }
  }
  return (
    <Wrapper>
      <InfiniteScroll
        dataLength={list.length}
        next={() => handleScroll(list[list.length - 1].id)}
        height={660}
        hasMore={hasMore}
      >
        {list.length>0 ? list.map(item => (
          <Popover overlayStyle={{display: 'none'}} onMouseEnter={() => handleVisibleChange(item.messageContent.messageId)} onMouseLeave={() => handleLeave()} key={item.id}>
            <Main className={uploadId === item.messageContent.messageId ? 'active': ''} key={item.messageContent.messageId}>
              <ShowImg src={fileFormat(item.messageContent.fileExt)}/>
              <Content>
                <Title>{item.messageContent.fileName}</Title>
                <Size>{calFileSize(item.messageContent.sdkSize)}</Size>
              </Content>
              <div>
                <Time>{moment(item.messageContent.createdAt).format('MM/DD')}</Time>
                {uploadId === item.messageContent.messageId ? <UploadImg src={IconUpload} onClick={() => downloadImg(item.messageContent.url)}/> : null}
              </div>
            </Main>
          </Popover>
        )) : <NoData>暂无数据</NoData>}
      </InfiniteScroll>
    </Wrapper>
  )
}

export default File
